import { ROUTES } from "@/constants/routes"
import { getLoginVerificationMessage, LOGIN_EXPIRED_REASON } from "@/utils/authSession"

export const SESSION_VERIFICATION_CONTEXT = {
  RESTORE: "restore",
  INTERACTION: "interaction",
}

export function getLoginVerificationAction(reason, { context, currentPath }) {
  const message = getLoginVerificationMessage(reason)
  if (!message) return null

  if (reason === LOGIN_EXPIRED_REASON) {
    return { message: "", route: { name: ROUTES.LOGIN.INDEX, query: { next: currentPath } } }
  }

  if (context === SESSION_VERIFICATION_CONTEXT.RESTORE) {
    return { message: "", route: { name: ROUTES.MAIN.INDEX } }
  }

  return {
    message,
    route: { name: ROUTES.LOGIN.INDEX, query: { next: currentPath } },
  }
}
